module.exports = __webpack_public_path__ + "static/media/cyber-attack.14ba4750.svg";